module.exports = __webpack_public_path__ + "static/media/dog-mastiff.86c01e2a.png";